import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, Inject, Injectable, Injector, InjectionToken, ErrorHandler } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './theme/shared/shared.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavLogoComponent } from './theme/layout/admin/navigation/nav-logo/nav-logo.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavSearchComponent } from './theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import { ChatUserListComponent } from './theme/layout/admin/nav-bar/nav-right/chat-user-list/chat-user-list.component';
import { FriendComponent } from './theme/layout/admin/nav-bar/nav-right/chat-user-list/friend/friend.component';
import { ChatMsgComponent } from './theme/layout/admin/nav-bar/nav-right/chat-msg/chat-msg.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';

import { ToggleFullScreenDirective } from './theme/shared/full-screen/toggle-full-screen';

/* Menu Items */
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NgbButtonsModule, NgbDropdownModule, NgbTabsetModule, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

/* Syncfusion */
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';

import { PortalModule } from '@angular/cdk/portal';
import { JwtInterceptor, ErrorInterceptor, AuthInterceptor } from '@app/core/helpers';
import { AuthService } from '@app/core/domain/auth';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { environment } from '@environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { FlexLayoutModule } from '@angular/flex-layout';
import { UrlTrackerService } from '@app/core/services/urlTracker.service';

// Custom loggers
import { LoggerConfigService } from '@app/core/services/logger-config.service';
import { LoggerService } from '@app/core/services/logger.service';

import { UnsavedChangesGuard } from '@app/theme/shared/components/UnsavedChangesGuard';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { NavService } from './core/services/nav.service';
import { basicLoader } from './core/helpers/auth/app.initializer';

@NgModule({
    declarations: [
        AppComponent,
        AdminComponent,
        AuthComponent,
        NavigationComponent,
        NavContentComponent,
        NavLogoComponent,
        NavGroupComponent,
        NavCollapseComponent,
        NavItemComponent,
        NavBarComponent,
        NavLeftComponent,
        NavSearchComponent,
        NavRightComponent,
        ChatUserListComponent,
        FriendComponent,
        ChatMsgComponent,
        ConfigurationComponent,
        ToggleFullScreenDirective,
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        NgbDropdownModule,
        NgbTooltipModule,
        NgbButtonsModule,
        NgbTabsetModule,
        NgbNavModule,
        PortalModule,
        GridModule,
        MultiSelectAllModule,
        LoggerModule.forRoot({
            // serverLoggingUrl: `${environment.apiUrl}/appops/log-ng-portal`,
            level: environment.logLevel,
            serverLogLevel: environment.serverLogLevel,
            disableConsoleLogging: false,
            enableSourceMaps: true,
        }),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        FlexLayoutModule,
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: basicLoader,
            deps: [NavService],
            multi: true,
        },
        // {
        //     provide: APP_INITIALIZER,
        //     useFactory: appUserLoader,
        //     deps: [AppUserLoaderService],
        //     multi: true,
        // },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: LoggerService, useClass: LoggerConfigService },
        UrlTrackerService,
        NavigationItem,
        AuthService,
        UnsavedChangesGuard,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
